import styled from "styled-components"

export const WelcomeOnboardingPage = styled.div`
  display: flex;
  padding: var(--Primitive-spacing_xxl, 32px) var(--app_side_margin, 16px) 24px
    var(--app_side_margin, 16px);
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: var(--spacing_xxl, 32px);
  flex: 1 0 0;
  align-self: stretch;

  color: #fff;
  height: 100%;
`

export const OverLay = styled.div`
  height: 100%;
  background: linear-gradient(
    180deg,
    #000 0.01%,
    rgba(0, 38, 58, 0.6) 35.08%,
    rgba(0, 38, 58, 0) 47.61%,
    rgba(0, 38, 58, 0) 75.95%,
    #000 99.99%
  );
  position: absolute;
  inset: 0;
`
export const StyledImage = styled.img`
  position: absolute;
  inset: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
`

export const Content = styled.div`
  padding: 0px 8px;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const SubTitle = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 19.6px */
  letter-spacing: 0.56px;
  text-transform: uppercase;
`

export const Title = styled.h1`
  font-size: 32px;
  font-style: normal;
  font-weight: 900;
  line-height: 120%;
  margin-top: 4px;
`

export const Description = styled.p`
  margin-top: 12px;
  color: var(--Primitive-White, #fff);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
  max-width: 327px;
  margin: 0;
`
